import { ErrorMapperBase } from 'CtxErrorMapper/ErrorMapperBase';
import { Remediation } from 'CtxErrorMapper/remediationMapper';
import { StoreFrontErrorDetail } from 'CtxErrorMapper/types';
import { ErrorConfigurationSchema, RemediationItem } from './errorConfigSchema';
import errorConfigJson from './errormap.json';

const DEFAULT_ERROR_CODE = 'default';
const defaultRecommendationMessageKey = 'DefaultRecommendationMessageKey';
const defaultErrorMessageKey = 'DefaultErrorMessageKey';

/*
	TODO: Add Enforcing code such that this class can be initialized only after environment init and 
	platform init since we need to find the current OS for correctly mapping the remediation.
*/
// allow-unused-export: will be used in a later PR
export class CtxErrorMapper extends ErrorMapperBase {
	private readonly storeFrontErrors: { [key: string]: StoreFrontErrorDetail };
	private static instance: CtxErrorMapper;

	private constructor(errorConfig: ErrorConfigurationSchema) {
		super(errorConfig);
		this.storeFrontErrors = errorConfig.errorDomain.StoreFront;
	}

	private getErrorDetails(errorCode: string): StoreFrontErrorDetail {
		return this.storeFrontErrors[errorCode] ?? this.storeFrontErrors[DEFAULT_ERROR_CODE];
	}

	public static getInstance(): CtxErrorMapper {
		if (!CtxErrorMapper.instance) {
			CtxErrorMapper.instance = new CtxErrorMapper(errorConfigJson);
		}
		return CtxErrorMapper.instance;
	}

	public getLocalizedDescription(errorCode: string): string {
		return (
			this.getLocalizedString(this.getErrorDetails(errorCode).errorDescriptionKey) ||
			this.getLocalizedString(defaultErrorMessageKey)
		);
	}

	public getLocalizedRecommendation(errorCode: string): string {
		return (
			this.getLocalizedString(this.getErrorDetails(errorCode).recommendationTextKey) ||
			this.getLocalizedString(defaultRecommendationMessageKey)
		);
	}

	public getRemediations(errorCode: string): Remediation[] {
		const remediationsForCurrentOS: RemediationItem[] =
			this.getErrorDetails(errorCode).remediations[this.remediationOSName];
		return remediationsForCurrentOS.map(
			remediation =>
				new Remediation(
					remediation,
					this.errorConfig,
					this.currentLocale,
					this.remediationOSName
				)
		);
	}
}
